(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/api/assets/javascripts/fetch-winners.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/api/assets/javascripts/fetch-winners.js');
"use strict";


let logger;
let jupiter;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  logger = trinidad.logger('module:bingo_react:components:api:fetchWinners');
  jupiter = trinidad.jupiter;
} else {
  logger = svs.core.log.getLogger('module:bingo_react:components:api:fetchWinners');
  jupiter = svs.core.jupiter;
}
const fetchWinners = async req => {
  try {
    const fetchOptions = {
      method: 'GET',
      path: '/casino/1/winnerfeed/bingo',
      req
    };
    const result = await jupiter.callAsync(fetchOptions);
    const winners = result.winnerFeed.items;
    return winners;
  } catch (e) {
    logger.error("Error fetching winners ".concat(e), req);
    throw e;
  }
};
if (svs.isServer) {
  module.exports = fetchWinners;
} else {
  setGlobal('svs.bingo_react.components.api.fetchWinners', fetchWinners);
}

 })(window);